export default {
    parts: ['content', 'body', 'header', 'title', 'closeButton'],
    baseStyle: {
        content: {
            position: 'fixed',
            top: '0',
            right: '0',
            height: '100vh',
            boxShadow: 'lg',
            borderRadius: 0,
            m: 0,
            color: 'webTypo.textPrimary'
        },
        body: {
            margin: 'auto',
            p: 0,
            width: '100%',
            overflowY: 'auto'
        },
        header: {
            align: 'center',
            justify: 'space-between',
            top: '0',
            zIndex: '1',
            background: 'white',
            w: '100%',
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary'
        },
        title: {
            textStyle: 'webH3'
        },
        closeButton: {
            variant: 'ghost',
            size: 'sm',
            background: 'transparent',
            _hover: {background: 'transparent'}
        }
    }
}
